import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../theme'

const Main = styled.footer`
  width: 100%;
  background: ${colors.white};
  border-top: 1px solid ${colors.line};
  color: ${colors.slate};
`

const Container = styled.div`
  max-width: 1400px;
  margin: auto;
  padding: 2rem 1.5rem 1rem;
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr;
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const Section = styled.div`
  h3 {
    margin: 0 0 0.8rem;
    color: ${colors.green};
    font-size: 1rem;
  }

  p,
  a {
    font-size: 0.9rem;
    color: ${colors.slate};
    text-decoration: none;
    line-height: 1.6;
    display: block;
    margin: 0 0 0.35rem;
  }

  a:hover {
    color: ${colors.green};
  }

  .tag {
    color: ${colors.red};
    font-weight: 700;
    letter-spacing: 0.5px;
    font-size: 0.78rem;
    margin-bottom: 0.5rem;
  }
`

const Bottom = styled.div`
  max-width: 1400px;
  margin: auto;
  padding: 1rem 1.5rem;
  border-top: 1px solid ${colors.line};
  text-align: center;
  font-size: 0.82rem;
  color: ${colors.slate};
`

const Footer = () => (
  <Main>
    <Container>
      <Section>
        <h3>Despar Clean — Management Dashboard</h3>
        <div className="tag">CLEAN. STERILE. TRUSTED.</div>
        <p>Monitor dispensers, M-Pesa payments, and detergent volume in real time.</p>
      </Section>

      <Section>
        <h3>Quick Links</h3>
        <Link to="/dashboard">Dashboard</Link>
        <Link to="/devices">Dispensers</Link>
        <Link to="/payments">Payments</Link>
        <Link to="/users">Users</Link>
      </Section>

      <Section>
        <h3>Contact</h3>
        <p>info@desparclean.com</p>
        <p>0723 437 122</p>
        <p>KSD Business Park, Embakasi, Nairobi</p>
      </Section>
    </Container>

    <Bottom>
      © {new Date().getFullYear()} Desparclean Sterix Holdings Limited. All rights reserved.
    </Bottom>
  </Main>
)

export default Footer
